import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AppointmentRequest } from '@app/models/appointmentRequest.model';
import { Site } from '@app/models/site.model';
import { SiteBookingSettings } from '@app/models/siteBookingSettings.model';
import { FeatureFlagService, FeatureKey } from '@app/services/feature-flag.service';
import { APPOINTMENT_REQUEST, CUSTOMER_ID, LocalStorageService, SITE, SITE_BOOKING_SETTINGS } from '@app/services/local-storage.service';

@Injectable({ providedIn: 'root' })
export class PathValidationGuard {
    retValue: boolean = true;
    constructor(
        private localStorageService: LocalStorageService,
        private router: Router,
        private featureFlagService: FeatureFlagService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): boolean {
        const rescheduleGuid = route.queryParams?.['reschedule'];
        if (rescheduleGuid) {
            if (route.routeConfig?.path === 'datetime') {
                return true;
            }
            return false;
        }
        const appointmentRequest = this.localStorageService.get(APPOINTMENT_REQUEST) as AppointmentRequest;
        const site = this.localStorageService.get(SITE) as Site;
        const siteBookingSettings = this.localStorageService.get(SITE_BOOKING_SETTINGS) as SiteBookingSettings;
        const supportsPets = site?.supportsPets;
        const pathValidationList = route.data.pathValidationList;
        this.retValue = true;

        const navigation = this.router.getCurrentNavigation();
        if (navigation && route.routeConfig?.path === 'booking/submitted' && navigation.extras.state?.shouldNavigate) {
            return true;
        }

        pathValidationList.forEach((element: any) => {
            if (element === 'service') {
                if (!appointmentRequest.service || appointmentRequest.service.length < 1) {
                    return this.navigateToRoute(element);
                }
            } else if (element === 'employee') {
                if (!appointmentRequest.employee || appointmentRequest.employee.length < 1) {
                    return this.navigateToRoute(element);
                }
            } else if (element === 'datetime') {
                const isRequestOnlyFeatureEnabled = this.featureFlagService.getFeatureFlag(FeatureKey.DSBRequestOnly);
                if (isRequestOnlyFeatureEnabled && siteBookingSettings?.requestAppointmentOnly) {
                    const hasDateTimeOfDay = !!appointmentRequest.dateTimeOfDayList?.length;
                    if (!hasDateTimeOfDay) {
                        return this.navigateToRoute(element);
                    }
                } else {
                    if (!appointmentRequest.datetime) {
                        return this.navigateToRoute(element);
                    }
                    const date = new Date(appointmentRequest.datetime);
                    if (isNaN(date.valueOf())) {
                        return this.navigateToRoute(element);
                    }
                }
            } else if (element === 'client' && !!!appointmentRequest?.rescheduleGuid) {
                if (!appointmentRequest.client || (supportsPets && !appointmentRequest.petInfo)) {
                    return this.navigateToRoute(element);
                }
            }
        });

        if (route.routeConfig?.path === 'booking/submitted') {
            return this.navigateToRoute('review');
        }
        return this.retValue;
    }

    navigateToRoute(partOfRoute: string): boolean {
        const customerID = this.localStorageService.getString(CUSTOMER_ID);

        void this.router.navigate(['/booking/' + partOfRoute], {
            queryParams: {
                DSID: customerID,
            },
        });
        this.retValue = false;
        return this.retValue;
    }
}
